import { overallReportstub, questionwiseReportStub } from "./stub-response"; 

export const overallReportAPI = async() => {
    try {
        let response = await new Promise((resolve) => {
          setTimeout(() => {
            let _data = overallReportstub;
            resolve(_data);
          }, 1000);
        });
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
}

export const qWiseReportAPI = async() => {
    try {
        let response = await new Promise((resolve) => {
          setTimeout(() => {
            let _data = questionwiseReportStub;
            resolve(_data);
          }, 1000);
        });
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
}